const type = 'SET_CUSTOMER_SEARCH_RESULT';

const setCustomerSearchResult = (data) => ({
  data,
  type,
});

export { type };
export default setCustomerSearchResult;
